export const ACCESS_TOKEN = 'Access-Token'
export const URL_PREFIX = 'https://xbih5.hydts.cn'
export const ATTACHMENT_PREFIX = 'https://xbih5.hydts.cn/api'
